import React from "react";
import styled from "styled-components";
import Lightbox from "react-images";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const SectionHeader = styled.h2`
  color: var(--dark-800);
  line-height: 1.44;
  font-size: ${props => (
    props.size === "big" ? '2rem' :
    props.size === "light" ? '1.15rem'  :
    props.size === "small" ? '1.185rem' : '1.55rem' ) || '1.55rem'};
  font-weight: ${props => (
    props.weight === "light" ? '400' :
    props.weight === "small" ? '400' : '500' ) || '500'};
  margin-top: ${props => props.mt ||'0'};
  margin-bottom: ${props => props.mb || '0'};
  padding-top: ${props => props.pt || '0'};
  padding-bottom: ${props => props.pb || '0'};

  @media (max-width: 767.9px) {
    font-size: ${props => (
    props.size === "big" ? '1.4rem' :
    props.size === "light" ? '.8rem'  :
    props.size === "small" ? '.9rem' : '1.1rem' ) || '1.1rem'};
  }
`;      
const ContainerWrapper = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  text-align: ${props => props.textAlign || 'inherit'};
  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
`;

const SectionWrapper = styled.section`
  width: 100%;
  background-color: ${props => props.backgroundColor || 'white'};
  margin-top: ${props => props.mt || '0'};
  margin-bottom: ${props => props.mb || '0'};
  padding-bottom: ${props => props.pb || '0'};
  padding-top: ${props => props.pt || '0'};
`;

const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FlexLeft = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;
const FlexSelfStart = styled.div`
  width: 100%;
  align-self: flex-start;
  justify-self: flex-start;
`;
const ListUnstyled = styled.ul`
  list-style: none;
  padding-left: 0;
`;
const NavStrip = styled.div`
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: hsl(217, 34%, 34%);
  position: relative;
  z-index: 2;
`;
const HomeCTA = styled(Link)`
  color: ${props => props.color || 'white'};
  font-size: ${props => props.fontSize || '1rem'};
  padding: 5px 20px;
  background-color: ${props => props.bgColor || 'hsl(120,40%,45%)'};
  border: 1px solid transparent;
  border-radius: 2px;
  cursor: pointer;
  position: relative;
  ${props => props.top ? `top: ${props.top}vh` : ''};
  transition: all .2s ease-out;

  &:hover {
    color: ${props => props.color || 'white'};
    background-color: ${props => props.hoverBgColor || 'hsl(120,40%,35%)'};
    border-color: ${props => props.hoverBorderColor || 'hsl(120,40%,35%)'};
  }
`;
const HrefCTA = styled.a`
  color: ${props => props.color || 'white'};
  font-size: ${props => props.fontSize || '1rem'};
  padding: 5px 20px;
  background-color: ${props => props.bgColor || 'hsl(120,40%,45%)'};
  border: 1px solid transparent;
  border-radius: 2px;
  cursor: pointer;
  position: relative;
  ${props => props.top ? `top: ${props.top}vh` : ''};
  transition: all .2s ease-out;

  &:hover {
    color: ${props => props.color || 'white'};
    background-color: ${props => props.hoverBgColor || 'hsl(120,40%,35%)'};
    border-color: ${props => props.hoverBorderColor || 'hsl(120,40%,35%)'};
  }
`;
const ButtonCTA = styled.button`
  color: ${props => props.color || 'white'};
  font-size: ${props => props.fontSize || '1rem'};
  font-family: inherit;
  line-height: inherit;
  padding: 5px 20px;
  background-color: ${props => props.bgColor || 'hsl(120,40%,45%)'};
  border: 1px solid transparent;
  border-radius: 2px;
  cursor: pointer;
  position: relative;
  ${props => props.top ? `top: ${props.top}vh` : ''};
  transition: all .2s ease-out;


  &:hover {
    color: ${props => props.color || 'white'};
    background-color: ${props => props.hoverBgColor || 'hsl(120,40%,35%)'};
    border-color: ${props => props.hoverBorderColor || 'hsl(120,40%,35%)'};
  }
`;

export function LightBoxModal (props) {
  let Photos = props.pictures.map(picture => {
    let srcPhoto = picture.srcMain || picture.src;
    let photoPath = require(`../../Images/Experience/Events/${srcPhoto}`); 
    let pObj = {};
    pObj["src"] = photoPath;
    pObj["caption"] = picture.caption;
    pObj["name"] = picture.name;
    return pObj;
  });
  return (
    <Lightbox
      images={Photos}
      isOpen={props.isLightBoxOpen}
      onClickPrev={props.gotoLightBoxPrev}
      onClickNext={props.gotoLightBoxNext}
      onClose={props.handleLightBoxClose}
      currentImage={props.isCurrentLightBoxImage}
    />
  );
}

export function HelmetTitle ({title}) {
  return (
    <Helmet>
      <title>GERS / {title}</title>
    </Helmet>
  );
}
export { 
  SectionHeader, 
  ContainerWrapper, 
  SectionWrapper, 
  FlexCenter, 
  FlexLeft,
  FlexEnd,
  FlexSelfStart,
  ListUnstyled,
  HomeCTA,
  HrefCTA,
  ButtonCTA,
  NavStrip,
}



// WEBPACK FOOTER //
// ./src/Components/Utils/index.js